import React from 'react';
import { useTranslation } from 'react-i18next';
import { Header, NavHeader, Page } from '../../components';
import Markdown from '../../components/markdown';
import { useFetchDocuments } from '../../hooks/documents/use-fetch-documents';

const RodoPage: React.FC = () => {
  const { t } = useTranslation('rodo');
  const { content } = useFetchDocuments('rodo');

  return (
    <Page
      className="rodo"
      header={
        <>
          <NavHeader />
          <Header title={t('rodoHeader')} />
        </>
      }
    >
      <Markdown content={content} />
    </Page>
  );
};

export default RodoPage;
